<template>
    <div v-if="filterCount">
        <div class="box">
            <div class="box-inner filter-options">
                <div class="title">Search Filters</div>
                <div class="filter-list">
                    <template v-if="useElastic">
                        <category-filter v-if="children.length" :items="children" :current="categoriesFiltered" @loaded="init" @bump="refresh"></category-filter>
                        <price-filter :items="price" @loaded="init" @bump="refresh" :current="prices"></price-filter>
                        <!-- <range-filter
                                handle="price"
                                :items="facets"
                                @loaded="init"
                                @bump="refresh"
                                v-if="aggregations['price']"
                                key="pricing"
                            >
                        </range-filter> -->
                        <!-- <category-filter :items="category" :current="categories" @loaded="init" @bump="refresh"></category-filter> -->

                        <template v-for="(agg, handle) in aggregations">
                            <text-filter
                                :handle="handle"
                                :items="agg"
                                @loaded="init"
                                @bump="refresh"
                                :key="handle"
                                v-if="handle != 'price' && handle != 'categories'"
                            >
                            </text-filter>
                        </template>
                    </template>
                    <template v-else>

                        <loop-category-filter
                            handle="Categories"
                            :categories="aggregations['Categories']"
                            @bump="refresh"
                        >
                        </loop-category-filter>

                        <range-filter
                            handle="Price"
                            :items="aggregations['Price']"
                            @loaded="init"
                            @bump="refresh"
                            key="Price"
                            v-if="aggregations['Price']"
                        >
                        </range-filter>
                        <hr>
                        <template v-for="(agg, handle) in aggregations">
                            <loop54-filter
                                :handle="handle"
                                :items="agg"
                                @loaded="init"
                                :enable="true"
                                @bump="refresh"
                                :key="handle"
                                v-if="handle != 'Price' && handle != 'Categories'"
                            ></loop54-filter>
                        </template>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Search from '../../Services/Search.js';
    import TextFilter from './Filters/TextFilter.vue';
    import PriceFilter from './Filters/PriceFilter.vue';
    import BrandFilter from './Filters/BrandFilter.vue';
    import CategoryFilter from './Filters/CategoryFilter.vue';
    import LoopCategoryFilter from './Filters/Loop54/Categories.vue';
    import RangeFilter from './Filters/RangeFilter.vue';

    export default {
        props: {
            useElastic: {
                type: Boolean,
                default: false,
            },
            categoriesFiltered: {
                type: String,
                default: null,
            },
            children: {
                type: Array,
                default() {
                    return []
                }
            },
            prices: {
                type: String,
                default: null,
            },
            categories: {
                type: Object,
                default() {
                    return {};
                }
            },
            aggregation: {
                type: Object,
                default() {
                    return {};
                }
            }
        },
        components: {
            CategoryFilter,
            PriceFilter,
            BrandFilter,
            TextFilter,
            RangeFilter,
            LoopCategoryFilter,
        },
        data() {
            return {
                search: Search,
                aggregations: [],
                price: [],
                elasticPricing: [],
                category: [],
            }
        },
        watch: {
            facets() {
                this.aggregations = this.facets;
            }
        },
        mounted() {
            this.price = this.aggregation.price;
            this.category = this.aggregation.categories;
            delete this.aggregation.price;
            delete this.aggregation.categories;
            this.aggregations = this.aggregation;
        },
        computed: {
            filterCount() {
                return _.size(this.aggregation);
            },
            facets() {
                return this.search.aggregations;
            }
        },
        methods: {
            refresh(filter) {
                this.search.addFilter(filter.field, filter).bump();
            },
            init(filter) {
                this.search.addFilter(filter.field, filter);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Search/SearchFilters.vue